import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import ConverList from '../components/ConverList.vue';
import moment from 'moment';
import PollList from '@/component/PollList/PollList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheConver',
  setup(__props) {

const moreLogs = ref<boolean>(true);
const selectId = ref<number | string>();
const preview_visible = ref<boolean>(false); // 控制示例图片显示和隐藏
const preview_image = ref<string>(''); // 示例图片预览路径
const data = [] as any;
for (let i = 1; i <= 100; i++) {
  data.push({
    id: i,
    name: 'Nld258471' + i,
    img: '',
    update_time: 1685087201,
    content: ['您好，我想咨询一下' + i],
  });
}
const send_info = ref<string>();
const logs = ref<any[]>([
  {
    id: 1,
    name: '田宇',
    img: '',
    content:
      '你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下你好，我想咨询一下',
    is_customer: 2,
    is_read: 1,
    create_time: 1685164915,
  },
  {
    id: 2,
    name: '王硕',
    img: '',
    content:
      'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.pngzxczxczxxzczxczxczxczxczxczxczxczxczxczxczxczxczxccccccccccccccccccccccccccccccccccccccccccccccccccccccccccczcxzcx',
    is_customer: 1,
    is_read: 1,
    create_time: 1685164915,
  },
]);
for (let i = 3; i <= 100; i++) {
  logs.value.push({
    id: i,
    name: i % 2 == 0 ? '田宇' : '王硕',
    img: '',
    content: ['您好，我想咨询一下' + i],
    is_customer: i % 2 == 0 ? 2 : 1,
    is_read: i % 2 == 0 ? 1 : 2,
    create_time: 1685164915 + i * 1000,
  });
}

watch(selectId, () => {
  console.log(selectId.value);
});
function onSend() {
  console.log('send_info', send_info.value);
  logs.value.push({
    id: 3,
    name: '王硕',
    img: '',
    content: send_info.value,
    is_customer: 1,
    is_read: 1,
    create_time: moment().format('X'),
  });
  send_info.value = '';
}
// 显示模态窗，改变模态窗中的图片路径
function handlePreview(e: any) {
  preview_image.value = e.target.src;
  preview_visible.value = true;
}
// 关闭模态窗
function handlePreviewCancel() {
  preview_visible.value = false;
}
// 更多记录
function onGetMoreLogs() {
  moreLogs.value = false;
}
function Format(time) {
  return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss');
}

return { __sfc: true,moreLogs, selectId, preview_visible, preview_image, data, send_info, logs, onSend, handlePreview, handlePreviewCancel, onGetMoreLogs, Format, ConverList }
}

})